import React from 'react'
import Jobs from './Jobs'

const Home = () => {
    return (
        <div className='text-white'>
            <Jobs />
        </div>
    )
}

export default Home
